import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import type { CalendarLens } from '@/entities/event'
import { isCustomerSession, useSession } from '@/entities/session'
import { fromISODate, toISODate } from '@/shared/lib'
import { CalendarBoard, useDefaultCalendarView } from '@/widgets/calendar-board'

const searchSchema = z.object({
  view: z.enum(['day', 'week', 'month']).optional().catch(undefined),
  date: z.string().optional().catch(undefined),
})

export const Route = createFileRoute('/_app/calendar')({
  validateSearch: (search: Record<string, unknown>) => searchSchema.parse(search),
  component: MyCalendarPage,
})

// Одна сетка на оба контура (00-architecture § 6). Сотрудник смотрит свой срез;
// заказчик — линзу своей компании, где бэк отдаёт только помеченные события
// (§ 4), и без действий записи: календарь для него витрина.
function MyCalendarPage() {
  const session = useSession()
  const search = Route.useSearch()
  const navigate = Route.useNavigate()
  const defaultView = useDefaultCalendarView()
  const view = search.view ?? defaultView
  const anchor = (search.date ? fromISODate(search.date) : null) ?? new Date()

  const customer = isCustomerSession(session)
  const lens: CalendarLens = customer
    ? { kind: 'company', id: session.companyId }
    : { kind: 'employee', id: session.employeeId }

  return (
    <div className="flex h-full min-h-0 flex-col">
      {customer && (
        <div className="flex flex-wrap items-center gap-x-2 gap-y-1 border-b px-gutter py-2">
          <span className="label">Ваш календарь</span>
          <span className="text-sm text-text-secondary">
            События, которые студия открыла вашей компании
          </span>
        </div>
      )}
      <CalendarBoard
        lens={lens}
        view={view}
        anchor={anchor}
        readOnly={customer}
        onViewChange={(v) => void navigate({ search: (s) => ({ ...s, view: v }) })}
        onAnchorChange={(d) => void navigate({ search: (s) => ({ ...s, date: toISODate(d) }) })}
      />
    </div>
  )
}
